import {Component, inject} from '@angular/core';
import {GameService} from "../../../services/game.service";
import {AgGridAngular} from "ag-grid-angular";
import {AsyncPipe} from "@angular/common";
import {ChooseYourGameComponent} from "../../../components/choose-your-game/choose-your-game.component";
import {ContainerComponent} from "@coreui/angular";
import {WinnerPayoutsComponent} from "../winner-payouts.component";

@Component({
  selector: 'app-game-admin-winner-payouts',
  standalone: true,
  imports: [
    AgGridAngular,
    AsyncPipe,
    ChooseYourGameComponent,
    ContainerComponent,
    WinnerPayoutsComponent
  ],
  templateUrl: './game-admin-winner-payouts.component.html',
  styleUrl: './game-admin-winner-payouts.component.css'
})
export class GameAdminWinnerPayoutsComponent {
  private gameService: GameService = inject(GameService);

  protected activeGame =  this.gameService.activeGame();
}
